import ClusterHubPage from '../../components/ClusterHubPage';
import { CLUSTERS } from '../../data/clusterConfig';
export default function HafizaBeyinTestleriHub() {
  return <ClusterHubPage cluster={CLUSTERS['hafiza-ve-beyin-testleri']} />;
}
